import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import React, { useEffect, useState } from 'react'
import Cookies from 'universal-cookie'
import { n_signup, s_signup } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import Input from '../../_legacy/Input'

const FriendCodeInputsNew: React.FC<any> = ({
  verifiedReferralCode,
  referralRef,
  handleCheckReferralCode,
  initialTabIndex,
  warningReferralCode,
}) => {
  const { t } = useTranslation()
  const cookies = new Cookies()
  const [loaded, setLoaded] = useState()
  const [referralValue, setReferralValue] = useState('')
  const referralCode = cookies.get('referralCode')

  useEffect(() => {
    if (referralCode) {
      referralRef.current.value = referralCode
      setReferralValue(referralCode)
    }
  }, [referralCode])

  useEffect(() => {
    if (referralCode) {
      setTimeout(() => {
        handleCheckReferralCode()
      }, 1000)
    }
  }, [])

  return (
    <>
      {/*-- Friend Code  --*/}
      <div className="">
        <div className="flex flex-row flex-nowrap">
          <div className="flex flex-row items-center justify-center w-full">
            <div className="mr-[8px] flex-1">
              <Input
                ref={referralRef}
                value={referralValue}
                type="text"
                onChange={(e) => setReferralValue(e.target.value)}
                error={!!warningReferralCode && !verifiedReferralCode}
                disabled={verifiedReferralCode}
                placeholder={t(n_signup.referral_code.code)}
                tabIndex={initialTabIndex + 2}
                style={{ padding: '16px', height: '52px' }}
                clx={
                  "placeholder:text-[16px] placeholder:text-gray-400 !pl-[40px] bg-[length:20px] bg-[left_14px_top_16px]  bg-no-repeat bg-[url('https://d38emex6h5e12i.cloudfront.net/2024-image/1713749320038_code.webp')]"
                }
              />
            </div>
          </div>
          <div className="min-w-[80px]">
            <DSButton
              disabled={verifiedReferralCode || !referralValue}
              type={BUTTON_TYPE.SOLID}
              size={BUTTON_SIZE.MD}
              className="h-[52px]"
              onClick={handleCheckReferralCode}
            >
              <DSButton.Label className="whitespace-nowrap">
                {verifiedReferralCode ? t(s_signup.verified) : t(s_signup.verify)}
              </DSButton.Label>
            </DSButton>
          </div>
        </div>
      </div>
    </>
  )
}

export default FriendCodeInputsNew
